<template>
  <div v-if="isVisible" class="popup-container">
    <div class="popup_bg"></div>
    <div id="myModal" class="modal_class">
      <div class="modal-content invoice" style="min-height: 300px !important; opacity: 1 !important">
        <div class="d-flex justify-content-between align-items-center p-0">
          <div class="d-flex p-0 align-items-center gap-3 w-100">
            <!-- Search Input -->
            <div class="position-relative w-80" style="max-width: 1200px">
              <i class="fas fa-search position-absolute" style="left: 20px; top: 50%; transform: translateY(-50%); color: gray;"></i>

              <div style="display: flex; align-items: center; gap: 10px">
                <input
                  v-if="typedata == 'realtime'"
                  type="text"
                  @keyup.enter="fetchData()"
                  v-model="search_field_realtime"
                  placeholder="Search..."
                  class="form-control input-text ps-5 bg-transparent text-dark input-border"
                  style="box-shadow: none; height: 42px; flex: 1"
                />
                <button
                  v-if="typedata == 'realtime'"
                  @click="fetchData"
                  class="bg-success btn text-white rounded py-0 mt-3"
                  style="height: 42px; padding: 0 20px"
                >
                  Submit
                </button>

                <input
                  v-if="typedata == 'pppoe'"
                  type="text"
                  @keyup.enter="graph(search_field)"
                  @input="filter_suggestions"
                  v-model="search_field"
                  placeholder="Search..."
                  class="form-control input-text ps-5 bg-transparent text-dark input-border"
                  style="box-shadow: none; height: 42px; flex: 1"
                />
              </div>

              <!-- PPPOE Search Suggetation -->
              <div
                v-if="search_field"
                class="suggestions position-absolute dark-mode-suggestions suggestions-box custom-scroll"
                style="z-index: 100000 !important; height: 180px !important; overflow-y: auto; top: 120% !important"
              >
                <ul class="suggestion-list">
                  <li
                    class="suggestion-item"
                    style="border: 1px solid transparent !important"
                    v-for="(data, index) in suggestions"
                    :key="index"
                  >
                    <p class="suggestion-text" @click="graph(data.PPPOE_ID)">
                      {{ data.PPPOE_ID }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Search type selection dropdown -->
            <div class="" style="width: 120px">
              <select
                v-model="typedata"
                @change="resetSearch"
                class="form-select input-text bg-transparent text-center input-border select"
                style="box-shadow: none; height: 42px"
              >
                <option value="" disabled selected hidden>Select</option>
                <option value="pppoe" class="input-text-select">PPPOE</option>
                <option value="realtime">Mac Find</option>
              </select>
            </div>
          </div>

          <!-- Close button -->
          <span class="">
            <span @click="resetAndClose" class="close item">&times;</span>
          </span>
        </div>

        <div v-if="searchData && typedata == 'realtime'"  class="olt-container">
          <!-- Sidebar with OLT list -->
          <div class="olt-sidebar">
            <div class="sidebar-header">Available OLTs</div>
            <div class="olt-list">
              <!-- Active OLTs Section -->
              <div v-if="hasActiveOlts" class="brand-section active-section">
                <div class="brand-header">
                  <i class="fas fa-server me-2"></i>
                  Active OLTs
                </div>
                <div 
                  v-for="brand in allBrands" 
                  :key="brand.olt_brand_name"
                  class="active-brand-group"
                >
                  <div v-if="hasActiveOltInBrand(brand)" class="active-brand-name" @click="autoScanBrand(brand.olt_brand_name)">
                    <i class="fas fa-server me-2"></i>
                    {{ brand.olt_brand_name }}
                  </div>
                  <div 
                    v-for="gpon in getActiveGponOlt(brand)" 
                    :key="gpon.oltid"
                    class="olt-item"
                    @click="setActiveOlt(gpon.oltid)"
                    :class="{ 'selected': activeOlt === gpon.oltid }"
                  >
                    <div class="olt-name">{{ gpon.olt_name }}</div>
                    <div class="olt-status">
                      <i v-if="cardStates[gpon.oltid]?.loading" class="fas fa-spinner fa-spin"></i>
                      <i v-else-if="cardStates[gpon.oltid]?.data" class="fas fa-check-circle success"></i>
                      <i v-else-if="cardStates[gpon.oltid]?.error" class="fas fa-exclamation-circle error"></i>
                    </div>
                  </div>
                  <div 
                    v-for="epon in getActiveEponOlt(brand)" 
                    :key="epon.oltid"
                    class="olt-item"
                    @click="setActiveOlt(epon.oltid)"
                    :class="{ 'selected': activeOlt === epon.oltid }"
                  >
                    <div class="olt-name">{{ epon.olt_name }}</div>
                    <div class="olt-status">
                      <i v-if="cardStates[epon.oltid]?.loading" class="fas fa-spinner fa-spin"></i>
                      <i v-else-if="cardStates[epon.oltid]?.data" class="fas fa-check-circle success"></i>
                      <i v-else-if="cardStates[epon.oltid]?.error" class="fas fa-exclamation-circle error"></i>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Other OLTs -->
              <div 
                v-for="brand in allBrands" 
                :key="brand.olt_brand_name"
                class="brand-section"
              >
                <div class="brand-header" @click="autoScanBrand(brand.olt_brand_name)">
                  <i class="fas fa-server me-2"></i>
                  {{ brand.olt_brand_name }}
                </div>
                <div 
                  v-for="gpon in filteredGponOlt(brand)" 
                  :key="gpon.oltid"
                  class="olt-item"
                  @click="setActiveOlt(gpon.oltid)"
                  :class="{ 'selected': activeOlt === gpon.oltid }"
                >
                  <div class="olt-name">{{ gpon.olt_name }}</div>
                  <div class="olt-status">
                    <i v-if="cardStates[gpon.oltid]?.loading" class="fas fa-spinner fa-spin"></i>
                    <i v-else-if="cardStates[gpon.oltid]?.data" class="fas fa-check-circle success"></i>
                    <i v-else-if="cardStates[gpon.oltid]?.error" class="fas fa-exclamation-circle error"></i>
                  </div>
                </div>
                <div 
                  v-for="epon in filteredEponOlt(brand)" 
                  :key="epon.oltid"
                  class="olt-item"
                  @click="setActiveOlt(epon.oltid)"
                  :class="{ 'selected': activeOlt === epon.oltid }"
                >
                  <div class="olt-name">{{ epon.olt_name }}</div>
                  <div class="olt-status">
                    <i v-if="cardStates[epon.oltid]?.loading" class="fas fa-spinner fa-spin"></i>
                    <i v-else-if="cardStates[epon.oltid]?.data" class="fas fa-check-circle success"></i>
                    <i v-else-if="cardStates[epon.oltid]?.error" class="fas fa-exclamation-circle error"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main content area for selected OLT -->
          <div class="olt-content">
            <div v-if="activeOlt && cardStates[activeOlt]?.data" class="olt-details">
              <!-- Basic Information - Hide for CDATA-V1.2 -->
              <div v-if="getBrandName(activeOlt) !== 'CDATA-V1.2'" class="detail-section">
                <h5>
                  <i class="fas fa-info-circle me-2"></i>
                  Basic Information
                </h5>
                <div class="data-grid">
                  <div class="data-item">
                    <span class="data-label">VLAN:</span>
                    <span class="data-value">{{ getDataValue(activeOlt, 'Vlan') || getDataValue(activeOlt, 'vlan') }}</span>
                  </div>
                  <div class="data-item">
                    <span class="data-label">MAC:</span>
                    <span class="data-value">{{ getDataValue(activeOlt, 'MacAddress') || getDataValue(activeOlt, 'mac_address') }}</span>
                  </div>
                  <div class="data-item">
                    <span class="data-label">Type:</span>
                    <span class="data-value">{{ getDataValue(activeOlt, 'Type') || getDataValue(activeOlt, 'type') }}</span>
                  </div>
                  <div class="data-item">
                    <span class="data-label">Port:</span>
                    <span class="data-value">{{ getDataValue(activeOlt, 'Ports') || getDataValue(activeOlt, 'port') }}</span>
                  </div>
                  <div class="data-item">
                    <span class="data-label">OLT ID:</span>
                    <span class="data-value">{{ getDataValue(activeOlt, 'OltID') || activeOlt }}</span>
                  </div>
                  <div class="data-item">
                    <span class="data-label">OLT Brand:</span>
                    <span class="data-value">{{ getDataValue(activeOlt, 'OltBrand') || getBrandName(activeOlt) }}</span>
                  </div>
                  <div class="data-item">
                    <span class="data-label">OLT Mode:</span>
                    <span class="data-value">{{ getDataValue(activeOlt, 'OltModes') || getOltMode(activeOlt) }}</span>
                  </div>
                  <div v-if="getDataValue(activeOlt, 'GponInterface')" class="data-item">
                    <span class="data-label">GPON Interface:</span>
                    <span class="data-value">{{ getDataValue(activeOlt, 'GponInterface') }}</span>
                  </div>
                  <div v-if="getDataValue(activeOlt, 'onu_id')" class="data-item">
                    <span class="data-label">ONU ID:</span>
                    <span class="data-value">{{ getDataValue(activeOlt, 'onu_id') }}</span>
                  </div>
                </div>
              </div>

              <!-- Optical Information -->
              <div class="detail-section">
                <h5>
                  <i class="fas fa-microchip me-2"></i>
                  Optical Information
                </h5>
                <div v-if="getOpticalData(activeOlt)" class="data-grid">
                  <!-- CDATA-V1.2 Specific Optical Data -->
                  <template v-if="getBrandName(activeOlt) === 'CDATA-V1.2'">
                    <div v-if="getOpticalData(activeOlt).tem !== undefined" class="data-item">
                      <span class="data-label">Temperature:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).tem }}°C</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).voltage !== undefined" class="data-item">
                      <span class="data-label">Voltage:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).voltage }}V</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).bias !== undefined" class="data-item">
                      <span class="data-label">Bias Current:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).bias }}mA</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).rx_power !== undefined" class="data-item">
                      <span class="data-label">Rx Power:</span>
                      <span class="data-value" :class="{
                        'text-success': parseFloat(getOpticalData(activeOlt).rx_power) > -24,
                        'text-warning': parseFloat(getOpticalData(activeOlt).rx_power) >= -30 && parseFloat(getOpticalData(activeOlt).rx_power) <= -25,
                        'text-danger': parseFloat(getOpticalData(activeOlt).rx_power) < -30
                      }">{{ getOpticalData(activeOlt).rx_power }}dBm</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).tx_power !== undefined" class="data-item">
                      <span class="data-label">Tx Power:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).tx_power }}dBm</span>
                    </div>
                    <div v-if="getDataValue(activeOlt, 'mac')" class="data-item">
                      <span class="data-label">MAC Address:</span>
                      <span class="data-value">{{ getDataValue(activeOlt, 'mac') }}</span>
                    </div>
                    <div v-if="getDataValue(activeOlt, 'onu_id')" class="data-item">
                      <span class="data-label">ONU ID:</span>
                      <span class="data-value">{{ getDataValue(activeOlt, 'onu_id') }}</span>
                    </div>
                    <div v-if="getDataValue(activeOlt, 'port_index')" class="data-item">
                      <span class="data-label">Port:</span>
                      <span class="data-value">{{ getDataValue(activeOlt, 'port_index') }}</span>
                    </div>
                    <div v-if="getDataValue(activeOlt, 'oid')" class="data-item">
                      <span class="data-label">OID:</span>
                      <span class="data-value">{{ getDataValue(activeOlt, 'oid') }}</span>
                    </div>
                  </template>

                  <!-- CDATA-GPON-CLOUDE-V1 Specific Optical Data -->
                  <template v-else-if="getBrandName(activeOlt) === 'CDATA-GPON-CLOUDE-V1'">
                    <div v-if="getOpticalData(activeOlt)?.Temperature !== undefined && getOpticalData(activeOlt).Temperature !== 0" class="data-item">
                      <span class="data-label">Temperature:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).Temperature }}°C</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt)?.Voltage !== undefined && getOpticalData(activeOlt).Voltage !== 0" class="data-item">
                      <span class="data-label">Voltage:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).Voltage }}V</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt)?.BiasCurrent !== undefined && getOpticalData(activeOlt).BiasCurrent !== 0" class="data-item">
                      <span class="data-label">Bias Current:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).BiasCurrent }}mA</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt)?.RxPower !== undefined && getOpticalData(activeOlt).RxPower !== 0" class="data-item">
                      <span class="data-label">Rx Power:</span>
                      <span class="data-value" :class="{
                        'text-success': parseFloat(getOpticalData(activeOlt).RxPower) > -24,
                        'text-warning': parseFloat(getOpticalData(activeOlt).RxPower) >= -30 && parseFloat(getOpticalData(activeOlt).RxPower) <= -25,
                        'text-danger': parseFloat(getOpticalData(activeOlt).RxPower) < -30
                      }">{{ getOpticalData(activeOlt).RxPower }}dBm</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt)?.TxPower !== undefined && getOpticalData(activeOlt).TxPower !== 0" class="data-item">
                      <span class="data-label">Tx Power:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).TxPower }}dBm</span>
                    </div>
                    <div v-if="getDataValue(activeOlt, 'MacAddress')" class="data-item">
                      <span class="data-label">MAC Address:</span>
                      <span class="data-value">{{ getDataValue(activeOlt, 'MacAddress') }}</span>
                    </div>
                    <div v-if="getDataValue(activeOlt, 'OnuId')" class="data-item">
                      <span class="data-label">ONU ID:</span>
                      <span class="data-value">{{ getDataValue(activeOlt, 'OnuId') }}</span>
                    </div>
                    <div v-if="getDataValue(activeOlt, 'PonId')" class="data-item">
                      <span class="data-label">PON ID:</span>
                      <span class="data-value">{{ getDataValue(activeOlt, 'PonId') }}</span>
                    </div>
                    <div v-if="getDataValue(activeOlt, 'PortIndex')" class="data-item">
                      <span class="data-label">Port:</span>
                      <span class="data-value">{{ getDataValue(activeOlt, 'PortIndex') }}</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt)?.Range !== undefined && getOpticalData(activeOlt).Range !== 0" class="data-item">
                      <span class="data-label">Range:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).Range }}m</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt)?.RXRate !== undefined && getOpticalData(activeOlt).RXRate !== 0" class="data-item">
                      <span class="data-label">RX Rate:</span>
                      <span class="data-value">{{ formatRate(getOpticalData(activeOlt).RXRate) }}</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt)?.TXRate !== undefined && getOpticalData(activeOlt).TXRate !== 0" class="data-item">
                      <span class="data-label">TX Rate:</span>
                      <span class="data-value">{{ formatRate(getOpticalData(activeOlt).TXRate) }}</span>
                    </div>
                  </template>

                  <!-- Existing Optical Data for other brands -->
                  <template v-else>
                    <div v-if="getOpticalData(activeOlt).Temperature !== undefined" class="data-item">
                      <span class="data-label">Temperature:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).Temperature }}°C</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).operatingtemperature !== undefined" class="data-item">
                      <span class="data-label">Temperature:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).operatingtemperature }}°C</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).Voltage !== undefined" class="data-item">
                      <span class="data-label">Voltage:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).Voltage }}V</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).supplyvoltage !== undefined" class="data-item">
                      <span class="data-label">Voltage:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).supplyvoltage }}V</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).Current !== undefined" class="data-item">
                      <span class="data-label">Current:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).Current }}mA</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).biascurrent !== undefined" class="data-item">
                      <span class="data-label">Current:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).biascurrent }}mA</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).RxPower !== undefined" class="data-item">
                      <span class="data-label">Rx Power:</span>
                      <span class="data-value" :class="{
                        'text-success': getOpticalData(activeOlt).RxPower > -24,
                        'text-warning': getOpticalData(activeOlt).RxPower >= -30 && getOpticalData(activeOlt).RxPower <= -25,
                        'text-danger': getOpticalData(activeOlt).RxPower < -30
                      }">{{ getOpticalData(activeOlt).RxPower }}dBm</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).receivedpower !== undefined" class="data-item">
                      <span class="data-label">Rx Power:</span>
                      <span class="data-value" :class="{
                        'text-success': getOpticalData(activeOlt).receivedpower > -24,
                        'text-warning': getOpticalData(activeOlt).receivedpower >= -30 && getOpticalData(activeOlt).receivedpower <= -25,
                        'text-danger': getOpticalData(activeOlt).receivedpower < -30
                      }">{{ getOpticalData(activeOlt).receivedpower }}dBm</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).TxPower !== undefined" class="data-item">
                      <span class="data-label">Tx Power:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).TxPower }}dBm</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).transmittedpower !== undefined" class="data-item">
                      <span class="data-label">Tx Power:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).transmittedpower }}dBm</span>
                    </div>
                    <div v-if="getOpticalData(activeOlt).BiasCurrent !== undefined" class="data-item">
                      <span class="data-label">Bias Current:</span>
                      <span class="data-value">{{ getOpticalData(activeOlt).BiasCurrent }}mA</span>
                    </div>
                  </template>
                </div>
                <div v-else class="no-data">
                  No optical data available
                </div>
              </div>
            </div>

            <div v-else-if="activeOlt && cardStates[activeOlt]?.error" class="olt-error">
              <div class="error-message">
                <i class="fas fa-exclamation-triangle"></i>
                <span>{{ cardStates[activeOlt].error }}</span>
              </div>
              <button @click="fetchOltData(activeOlt, getOltType(activeOlt))" class="retry-btn">
                <i class="fas fa-sync-alt"></i> Retry
              </button>
            </div>

            <div v-else-if="activeOlt && cardStates[activeOlt]?.loading" class="olt-loading">
              <i class="fas fa-spinner fa-spin"></i>
              <span>Loading OLT data...</span>
            </div>

            <div v-else class="olt-empty">
              <i class="fas fa-info-circle"></i>
              <span>Select an OLT from the sidebar to view details</span>
            </div>
          </div>
        </div>

        <div v-else>
          <div v-if="loader_data">
            <Skalaton />
          </div>
          <div v-if="error">
            <p style="color:red !important">{{error}}</p>
          </div>
          <div class="d-flex align-items-center justify-content-between mt-5">            
            <p class="w-50">Regular Search</p>
            <p class="w-50">Realtime Search</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps, defineEmits, onMounted, watch, computed } from "vue";
import { useSearchApi } from "../services/search.service";
import getUniquePPOE from "@/services/unique_pppoe_ids.service";
import { useRouter } from "vue-router";
import Skalaton from "@/components/Skalaton.vue";

const router = useRouter();

defineProps({
  isVisible: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["close-popup"]);

// State variables
const loader_data = ref(false);
const searchData = ref([]);
const typedata = ref("realtime");
const UniquePPOE_data = ref([]);
const suggestions = ref([]);
const search_field = ref("");
const search_field_realtime = ref("");
const error = ref("");
const cardStates = ref({});
const activeOlt = ref(null);
const user = ref(JSON.parse(localStorage.getItem("user_data")));
const selectedBrand = ref(null);
const isScanning = ref(false);
const currentScanAbortController = ref(null);

// Computed properties
const allBrands = computed(() => searchData.value);

const hasActiveOlts = computed(() => {
  return allBrands.value.some(brand => 
    hasActiveOltInBrand(brand)
  );
});

const filteredGponOlt = computed(() => (brand) => {
  return (brand.GPON || []).filter(gpon => !cardStates.value[gpon.oltid]?.data);
});

const filteredEponOlt = computed(() => (brand) => {
  return (brand.EPON || []).filter(epon => !cardStates.value[epon.oltid]?.data);
});

// Methods
const resetAndClose = () => {
  stopCurrentScan();
  searchData.value = [];
  typedata.value = "realtime";
  search_field_realtime.value = "";
  error.value = "";
  cardStates.value = {};
  activeOlt.value = null;
  selectedBrand.value = null;
  isScanning.value = false;
  emit('close-popup');
};

const fetchData = async () => {
  resetSearch();
  loader_data.value = true;
  try {
    let user = JSON.parse(localStorage.getItem("user_data"));
    // Reset cardStates before making new search
    cardStates.value = {};
    activeOlt.value = null;
    selectedBrand.value = null;
    isScanning.value = false;
    const response = await useSearchApi().getOltBnd(user.fendy_user_id);
    searchData.value = response.olts;
  } catch (err) {
    console.error("Error fetching data:", err.response?.data?.error || err.message);
    error.value = err.response?.data?.error || "Failed to fetch OLT data";
  } finally {
    setTimeout(() => {
      loader_data.value = false;
    }, 1000);
  }
};

// Stop current scan
const stopCurrentScan = () => {
  if (currentScanAbortController.value) {
    currentScanAbortController.value.abort();
    currentScanAbortController.value = null;
  }
  isScanning.value = false;
};

// New method to auto-scan a specific brand
const autoScanBrand = async (brandName) => {
  if (!search_field_realtime.value) {
    error.value = "Please enter a MAC address first";
    return;
  }
  
  console.log(`Starting auto-scan for brand: ${brandName}`);
  
  // Stop any ongoing scans
  stopCurrentScan();
  
  // Create new abort controller
  currentScanAbortController.value = new AbortController();
  const signal = currentScanAbortController.value.signal;
  
  // Reset card states for all OLTs to stop previous scans
  const resetCardStates = { ...cardStates.value };
  Object.keys(resetCardStates).forEach(oltid => {
    if (resetCardStates[oltid]?.loading) {
      resetCardStates[oltid] = {
        ...resetCardStates[oltid],
        loading: false,
        error: "Scan cancelled"
      };
    }
  });
  cardStates.value = resetCardStates;
  
  selectedBrand.value = brandName;
  activeOlt.value = null;
  isScanning.value = true;
  
  // Find the selected brand
  const brand = allBrands.value.find(b => b.olt_brand_name === brandName);
  if (!brand) {
    console.error(`Brand ${brandName} not found`);
    isScanning.value = false;
    return;
  }
  
  try {
    // Start scanning OLTs for this brand only
    await scanBrandOLTs(brand, signal);
  } catch (error) {
    if (error.name !== 'AbortError') {
      console.error('Auto-scan error:', error);
    }
  } finally {
    if (!signal.aborted) {
      isScanning.value = false;
    }
    console.log(`Auto-scan completed for brand: ${brandName}`);
  }
};

// Separate function to scan OLTs for a specific brand
const scanBrandOLTs = async (brand, signal) => {
  const brandName = brand.olt_brand_name;
  
  if (brandName === 'BDCOM') {
    if (brand.GPON) {
      for (const gpon of brand.GPON) {
        if (signal.aborted) break;
        await fetchOltDataForBrand(gpon.oltid, 'gpon', signal);
      }
    }
    if (brand.EPON) {
      for (const epon of brand.EPON) {
        if (signal.aborted) break;
        await fetchOltDataForBrand(epon.oltid, 'epon', signal);
      }
    }
  } 
  else if (brandName === 'VSOL') {
    if (brand.EPON) {
      for (const epon of brand.EPON) {
        if (signal.aborted) break;
        await fetchOltDataForBrand(epon.oltid, 'vsol-epon', signal);
      }
    }
  }
  else if (brandName === 'AVIES') {
    if (brand.EPON) {
      for (const epon of brand.EPON) {
        if (signal.aborted) break;
        await fetchOltDataForBrand(epon.oltid, 'avies-epon', signal);
      }
    }
  }
  else if (brandName === 'CDATA') {
    if (brand.EPON) {
      for (const epon of brand.EPON) {
        if (signal.aborted) break;
        await fetchOltDataForBrand(epon.oltid, 'cdata-epon', signal);
      }
    }
  }
  else if (brandName === 'CDATA-V1.2') {
    if (brand.EPON) {
      for (const epon of brand.EPON) {
        if (signal.aborted) break;
        await fetchOltDataForBrand(epon.oltid, 'cdata-v1.2-epon', signal);
      }
    }
  }
  else if (brandName === 'CDATA-CLOUDE-EPON') {
    if (brand.EPON) {
      for (const epon of brand.EPON) {
        if (signal.aborted) break;
        await fetchOltDataForBrand(epon.oltid, 'cdata-cloude-epon', signal);
      }
    }
  }
  else if (brandName === 'CDATA-GPON-CLOUDE-V1') {
    if (brand.GPON) {
      for (const gpon of brand.GPON) {
        if (signal.aborted) break;
        await fetchOltDataForBrand(gpon.oltid, 'cdata-gpon-cloude-v1', signal);
      }
    }
  }
};

// Separate function for brand-specific scanning with abort signal
const fetchOltDataForBrand = async (oltid, type, signal) => {
  if (!search_field_realtime.value || signal.aborted) {
    return;
  }

  // Update card state to loading
  cardStates.value = {
    ...cardStates.value,
    [oltid]: {
      loading: true,
      data: null,
      error: null
    }
  };

  try {
    let response;
    
    switch(type) {
      case 'gpon':
        response = await useSearchApi().getGponMacFiend(
          search_field_realtime.value,
          oltid,
          { signal }
        );
        break;
      case 'epon':
        try {
          response = await useSearchApi().getEponMacFiend(
            search_field_realtime.value,
            oltid,
            { signal }
          );
        } catch (err) {
          if (err.name === 'AbortError') throw err;
          console.error(`BDCOM EPON failed, trying VSOL EPON for OLT ${oltid}:`, err);
          response = await useSearchApi().getVsolEponMacFiend(
            search_field_realtime.value,
            oltid,
            { signal }
          );
        }
        break;
      case 'vsol-epon':
        response = await useSearchApi().getVsolEponMacFiend(
          search_field_realtime.value,
          oltid,
          { signal }
        );
        break;
      case 'avies-epon':
        response = await useSearchApi().getAviesMacFiend(
          search_field_realtime.value,
          oltid,
          { signal }
        );
        break;
      case 'cdata-epon':
        response = await useSearchApi().getCdataMacFiend(
          search_field_realtime.value,
          oltid,
          { signal }
        );
        break;
      case 'cdata-v1.2-epon':
        response = await useSearchApi().getCdataMacFinder(
          oltid,
          search_field_realtime.value,
          { signal }
        );
        break;
      case 'cdata-cloude-epon':
        response = await useSearchApi().getCdataCLoudeMacFinder(
          oltid,
          search_field_realtime.value,
          { signal }
        );
        break;
      case 'cdata-gpon-cloude-v1':
        response = await useSearchApi().getCdataGponCloudeMacFinder(
          oltid,
          search_field_realtime.value,
          { signal }
        );
        break;
      default:
        throw new Error("Invalid OLT type");
    }

    // Success state update
    if (!signal.aborted) {
      cardStates.value = {
        ...cardStates.value,
        [oltid]: {
          loading: false,
          data: response,
          error: null
        }
      };

      // Automatically select the first OLT with data
      if (!activeOlt.value && response) {
        activeOlt.value = oltid;
      }
    }
  } catch (err) {
    if (err.name === 'AbortError') {
      // Request was cancelled, don't show error
      cardStates.value = {
        ...cardStates.value,
        [oltid]: {
          loading: false,
          data: null,
          error: "Scan cancelled"
        }
      };
      return;
    }
    
    console.error(`Error fetching data for OLT ${oltid}:`, err);
    // Error state update
    if (!signal.aborted) {
      cardStates.value = {
        ...cardStates.value,
        [oltid]: {
          loading: false,
          data: null,
          error: err.response?.data?.error || "Failed to fetch data"
        }
      };
    }
  }
};

// Keep the original watch function as is for initial loading
watch(searchData, async (newVal) => {
  if (!newVal || !newVal.length || isScanning.value) return;

  // Process each OLT brand in the response sequentially
  for (const brand of newVal) {
    if (currentScanAbortController.value?.signal.aborted) break;
    
    if (brand.olt_brand_name === 'BDCOM') {
      if (brand.GPON) {
        for (const gpon of brand.GPON) {
          if (currentScanAbortController.value?.signal.aborted) break;
          await fetchOltData(gpon.oltid, 'gpon');
        }
      }
      if (brand.EPON) {
        for (const epon of brand.EPON) {
          if (currentScanAbortController.value?.signal.aborted) break;
          await fetchOltData(epon.oltid, 'epon');
        }
      }
    } 
    else if (brand.olt_brand_name === 'VSOL') {
      if (brand.EPON) {
        for (const epon of brand.EPON) {
          if (currentScanAbortController.value?.signal.aborted) break;
          await fetchOltData(epon.oltid, 'vsol-epon');
        }
      }
    }
    else if (brand.olt_brand_name === 'AVIES') {
      if (brand.EPON) {
        for (const epon of brand.EPON) {
          if (currentScanAbortController.value?.signal.aborted) break;
          await fetchOltData(epon.oltid, 'avies-epon');
        }
      }
    }
    else if (brand.olt_brand_name === 'CDATA') {
      if (brand.EPON) {
        for (const epon of brand.EPON) {
          if (currentScanAbortController.value?.signal.aborted) break;
          await fetchOltData(epon.oltid, 'cdata-epon');
        }
      }
    }
    else if (brand.olt_brand_name === 'CDATA-V1.2') {
      if (brand.EPON) {
        for (const epon of brand.EPON) {
          if (currentScanAbortController.value?.signal.aborted) break;
          await fetchOltData(epon.oltid, 'cdata-v1.2-epon');
        }
      }
    }
    else if (brand.olt_brand_name === 'CDATA-CLOUDE-EPON') {
      if (brand.EPON) {
        for (const epon of brand.EPON) {
          if (currentScanAbortController.value?.signal.aborted) break;
          await fetchOltData(epon.oltid, 'cdata-cloude-epon');
        }
      }
    }
    else if (brand.olt_brand_name === 'CDATA-GPON-CLOUDE-V1') {
      if (brand.GPON) {
        for (const gpon of brand.GPON) {
          if (currentScanAbortController.value?.signal.aborted) break;
          await fetchOltData(gpon.oltid, 'cdata-gpon-cloude-v1');
        }
      }
    }
  }
}, { deep: true });

// Original fetchOltData function (for initial load)
const fetchOltData = async (oltid, type) => {
  if (!search_field_realtime.value) return;

  // Create a completely new state object in one atomic operation
  const updateCardState = (newState) => {
    cardStates.value = {
      ...cardStates.value,
      [oltid]: {
        ...cardStates.value[oltid],
        ...newState
      }
    };
  };

  // Initial loading state
  updateCardState({
    loading: true,
    error: null
  });

  try {
    let response;
    
    switch(type) {
      case 'gpon':
        response = await useSearchApi().getGponMacFiend(
          search_field_realtime.value,
          oltid
        );
        break;
      case 'epon':
        try {
          response = await useSearchApi().getEponMacFiend(
            search_field_realtime.value,
            oltid
          );
        } catch (err) {
          console.error(`BDCOM EPON failed, trying VSOL EPON for OLT ${oltid}:`, err);
          response = await useSearchApi().getVsolEponMacFiend(
            search_field_realtime.value,
            oltid
          );
        }
        break;
      case 'vsol-epon':
        response = await useSearchApi().getVsolEponMacFiend(
          search_field_realtime.value,
          oltid
        );
        break;
      case 'avies-epon':
        response = await useSearchApi().getAviesMacFiend(
          search_field_realtime.value,
          oltid
        );
        break;
      case 'cdata-epon':
        response = await useSearchApi().getCdataMacFiend(
          search_field_realtime.value,
          oltid
        );
        break;
      case 'cdata-v1.2-epon':
        response = await useSearchApi().getCdataMacFinder(
          oltid,
          search_field_realtime.value
        );
        break;
      case 'cdata-cloude-epon':
        response = await useSearchApi().getCdataCloudeMacFinder(
          search_field_realtime.value,
          oltid
        );
        break;
      case 'cdata-gpon-cloude-v1':
        response = await useSearchApi().getCdataGponCloudeMacFinder(
          oltid,
          search_field_realtime.value
        );
        break;
      default:
        throw new Error("Invalid OLT type");
    }

    // Success state update
    updateCardState({
      loading: false,
      data: response,
      error: null
    });

    // Automatically select the first OLT with data
    if (!activeOlt.value && response) {
      activeOlt.value = oltid;
    }
  } catch (err) {
    console.error(`Error fetching data for OLT ${oltid}:`, err);
    // Error state update
    updateCardState({
      loading: false,
      data: null,
      error: err.response?.data?.error || "Failed to fetch data"
    });
  }
};

const setActiveOlt = (oltid) => {
  activeOlt.value = oltid;
  // If the OLT doesn't have data yet, fetch it
  if (!cardStates.value[oltid]?.data && !cardStates.value[oltid]?.loading) {
    const type = getOltType(oltid);
    fetchOltData(oltid, type);
  }
};

const getDataValue = (oltid, field) => {
  if (!cardStates.value[oltid]?.data) return null;
  
  const data = cardStates.value[oltid].data;
  const brand = getBrandName(oltid);
  
  // Handle CDATA-GPON-CLOUDE-V1 specifically
  if (brand === 'CDATA-GPON-CLOUDE-V1') {
    // For CDATA-GPON-CLOUDE-V1, data is in data.data.MacArray[0]
    if (data.data && data.data.MacArray && Array.isArray(data.data.MacArray) && data.data.MacArray.length > 0) {
      const macItem = data.data.MacArray[0];
      // Check both MacArray item and OnuDetail
      return macItem[field] || macItem[field.toLowerCase()] || 
             macItem.OnuDetail?.[field] || macItem.OnuDetail?.[field.toLowerCase()] || null;
    }
    return null;
  }
  
  // Handle different response structures
  if (data.data) {
    if (Array.isArray(data.data)) {
      return data.data[0]?.[field] || data.data[0]?.[field.toLowerCase()];
    }
    return data.data[field] || data.data[field.toLowerCase()];
  }
  
  if (Array.isArray(data)) {
    return data[0]?.[field] || data[0]?.[field.toLowerCase()];
  }
  
  return data[field] || data[field.toLowerCase()];
};

const getOpticalData = (oltid) => {
  if (!cardStates.value[oltid]?.data) return null;
  
  const data = cardStates.value[oltid].data;
  const brand = getBrandName(oltid);
  
  // Handle CDATA-V1.2 specifically
  if (brand === 'CDATA-V1.2') {
    // For CDATA-V1.2, the entire response is optical data
    if (data.data) {
      if (Array.isArray(data.data)) {
        return data.data[0] || data.data;
      }
      return data.data;
    }
    
    if (Array.isArray(data)) {
      return data[0] || data;
    }
    
    return data;
  }
  
  // Handle CDATA-GPON-CLOUDE-V1 specifically
  if (brand === 'CDATA-GPON-CLOUDE-V1') {
    // For CDATA-GPON-CLOUDE-V1, optical data is in data.data.MacArray[0].OnuDetail
    if (data.data && data.data.MacArray && Array.isArray(data.data.MacArray) && data.data.MacArray.length > 0) {
      return data.data.MacArray[0].OnuDetail || null;
    }
    return null;
  }
  
  // Handle different response structures for other brands
  if (data.data) {
    if (Array.isArray(data.data)) {
      return data.data[0]?.OpticalInfo || data.data[0]?.EPONData || 
             data.data[0]?.diagnostic || data.data[0]?.optical_info ||
             data.data[0]?.ap2_data?.data || null;
    }
    return data.data.OpticalInfo || data.data.diagnostic || 
           data.data.optical_info || data.data.ap2_data?.data || null;
  }
  
  if (Array.isArray(data)) {
    return data[0]?.OpticalInfo || data[0]?.EPONData || 
           data[0]?.diagnostic || data[0]?.optical_info ||
           data[0]?.ap2_data?.data || null;
  }
  
  return data.OpticalInfo || data.diagnostic || 
         data.optical_info || data.ap2_data?.data || null;
};

const getBrandName = (oltid) => {
  for (const brand of searchData.value) {
    if (brand.GPON) {
      const gpon = brand.GPON.find(g => g.oltid === oltid);
      if (gpon) return brand.olt_brand_name;
    }
    if (brand.EPON) {
      const epon = brand.EPON.find(e => e.oltid === oltid);
      if (epon) return brand.olt_brand_name;
    }
  }
  return 'Unknown';
};

const getOltMode = (oltid) => {
  for (const brand of searchData.value) {
    if (brand.GPON) {
      const gpon = brand.GPON.find(g => g.oltid === oltid);
      if (gpon) return 'GPON';
    }
    if (brand.EPON) {
      const epon = brand.EPON.find(e => e.oltid === oltid);
      if (epon) return 'EPON';
    }
  }
  return 'Unknown';
};

const getOltType = (oltid) => {
  for (const brand of searchData.value) {
    if (brand.olt_brand_name === 'BDCOM') {
      if (brand.GPON && brand.GPON.some(g => g.oltid === oltid)) return 'gpon';
      if (brand.EPON && brand.EPON.some(e => e.oltid === oltid)) return 'epon';
    }
    else if (brand.olt_brand_name === 'VSOL') {
      if (brand.EPON && brand.EPON.some(e => e.oltid === oltid)) return 'vsol-epon';
    }
    else if (brand.olt_brand_name === 'AVIES') {
      if (brand.EPON && brand.EPON.some(e => e.oltid === oltid)) return 'avies-epon';
    }
    else if (brand.olt_brand_name === 'CDATA') {
      if (brand.EPON && brand.EPON.some(e => e.oltid === oltid)) return 'cdata-epon';
    }
    else if (brand.olt_brand_name === 'CDATA-V1.2') {
      if (brand.EPON && brand.EPON.some(e => e.oltid === oltid)) return 'cdata-v1.2-epon';
    }
    else if (brand.olt_brand_name === 'CDATA-CLOUDE-EPON') {
      if (brand.EPON && brand.EPON.some(e => e.oltid === oltid)) return 'cdata-cloude-epon';
    }
    else if (brand.olt_brand_name === 'CDATA-GPON-CLOUDE-V1') {
      if (brand.GPON && brand.GPON.some(g => g.oltid === oltid)) return 'cdata-gpon-cloude-v1';
    }
  }
  return 'unknown';
};

const getData = async () => {
  try {
    const response = await getUniquePPOE.getUniquePPOE();
    UniquePPOE_data.value = response;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

const resetSearch = () => {
  // Abort any ongoing requests
  stopCurrentScan();
  
  suggestions.value = [];
  loader_data.value = false;
  search_field.value = "";
  searchData.value = [];
  cardStates.value = {};
  activeOlt.value = null;
  selectedBrand.value = null;
  isScanning.value = false;
};

const graph = async (value) => {
  try {
    router.push({ name: "Graph", params: { pppoe: value } });
    search_field.value = "";
    emit("close-popup");
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

const filter_suggestions = async () => {
  try {
    suggestions.value = UniquePPOE_data.value.filter((item) =>
      item.PPPOE_ID.includes(search_field.value)
    );
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

const getActiveOltName = () => {
  if (!activeOlt.value) return '';
  
  for (const brand of searchData.value) {
    if (brand.GPON) {
      const gpon = brand.GPON.find(g => g.oltid === activeOlt.value);
      if (gpon) return gpon.olt_name;
    }
    if (brand.EPON) {
      const epon = brand.EPON.find(e => e.oltid === activeOlt.value);
      if (epon) return epon.olt_name;
    }
  }
  return '';
};

const hasActiveOltInBrand = (brand) => {
  const hasActiveGpon = brand.GPON?.some(gpon => cardStates.value[gpon.oltid]?.data);
  const hasActiveEpon = brand.EPON?.some(epon => cardStates.value[epon.oltid]?.data);
  return hasActiveGpon || hasActiveEpon;
};

const getActiveGponOlt = (brand) => {
  return (brand.GPON || []).filter(gpon => cardStates.value[gpon.oltid]?.data);
};

const getActiveEponOlt = (brand) => {
  return (brand.EPON || []).filter(epon => cardStates.value[epon.oltid]?.data);
};

const formatRate = (rate) => {
  if (!rate || rate === 0) return 'N/A';
  if (rate >= 1000000000) {
    return (rate / 1000000000).toFixed(2) + ' Gbps';
  } else if (rate >= 1000000) {
    return (rate / 1000000).toFixed(2) + ' Mbps';
  } else if (rate >= 1000) {
    return (rate / 1000).toFixed(2) + ' Kbps';
  }
  return rate + ' bps';
};

onMounted(() => {
  getData();
});
</script>

<style scoped>
/* Main Container */
.popup-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.popup_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #000000;
  max-width: 90%;
  width: 1200px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

/* OLT Container */
.olt-container {
  display: flex;
  height: 600px;
  overflow: hidden;
}

/* Sidebar Styles */
.olt-sidebar {
  width: 300px;
  background-color: #213550;
  color: white;
  overflow-y: auto;
  border-right: 1px solid #e0e0e0;
}

.sidebar-header {
  padding: 15px;
  font-weight: bold;
  font-size: 1.1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: #1a2a3f;
}

.olt-list {
  padding: 10px 0;
}

.brand-section {
  margin-bottom: 15px;
}

.brand-header {
  padding: 10px 15px;
  font-weight: 600;
  color: #4CAF50;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(76, 175, 80, 0.3);
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.brand-header:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.brand-header i {
  font-size: 1rem;
  opacity: 0.8;
}

.active-section .brand-header {
  color: #ffffff;
  font-weight: bold;
  padding: 10px 15px;
  background-color: transparent;
  margin-bottom: 10px;
}

.active-section .brand-header i {
  color: #ffffff;
  opacity: 0.8;
}

.olt-item {
  padding: 12px 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  margin: 0 10px;
}

.olt-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.olt-item.selected {
  background-color: rgba(76, 175, 80, 0.1);
  border-left: 3px solid #4CAF50;
}

.olt-item.selected .olt-name {
  color: #4CAF50;
  font-weight: 500;
}

.olt-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.olt-status {
  margin-left: 10px;
  font-size: 14px;
}

.olt-status .success {
  color: #4CAF50;
}

.olt-status .error {
  color: #F44336;
}

/* Content Area Styles */
.olt-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: #18293E;
}

.olt-details {
  background-color: #20344F;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.detail-section {
  margin-bottom: 25px;
}

.detail-section h5 {
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
  color: #213550;
  display: flex;
  align-items: center;
}

.detail-section h5 i {
  color: #4CAF50;
  font-size: 1.2em;
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
}

.data-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background-color: #18293E;
  border-radius: 4px;
}

.data-label {
  font-weight: 600;
  color: #555;
}

.data-value {
  color: #213550;
  font-weight: 500;
}

/* State Styles */
.olt-loading,
.olt-error,
.olt-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
  text-align: center;
  padding: 40px;
}

.olt-loading i,
.olt-error i,
.olt-empty i {
  font-size: 3rem;
  margin-bottom: 20px;
  color: #213550;
}

.olt-error i {
  color: #F44336;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  color: #F44336;
  font-weight: 500;
}

.retry-btn {
  padding: 8px 20px;
  background-color: #213550;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.retry-btn:hover {
  background-color: #1a2a3f;
}

.retry-btn i {
  margin-right: 8px;
}

.no-data {
  color: #999;
  font-style: italic;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 4px;
  text-align: center;
}

/* Custom Scrollbar Styles */
.custom-scroll::-webkit-scrollbar {
  width: 8px !important;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background-color: #555 !important;
  border-radius: 4px !important;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #888 !important;
}

.custom-scroll::-webkit-scrollbar-track {
  background-color: #9e9c9cbd !important;
  border-radius: 4px !important;
}

/* Header Styles */
.item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  cursor: pointer;
  border-radius: 100%;
  background-color: #2919041c;
  color: rgb(10, 0, 0) !important;
  background-color: #180f021c;
}

.dark-mode .item {
  color: white !important;
  background-color: #ffffff27;
}

.dark-mode .item:hover {
  background-color: #ffffff3a !important;
}

.item:hover {
  background-color: rgba(41, 25, 4, 0.11);
  transition: all;
  transition-duration: 500ms;
}

.input-border {
  border: 1px solid rgba(128, 128, 128, 0.233);
}
.text-sm {
  font-size: 14px !important;
}

.input-text {
  color: black !important;
}
.dark-mode .input-text {
  color: white !important;
}
.dark-mode .input-text-select {
  color: gainsboro !important;
}
.dark-mode .select {
  background-color: #041d3c !important;
}

.suggestion-item {
  cursor: pointer !important;
}
.suggestion-item:hover .suggestion-text {
  color: black !important;
  transition: all;
  transition-duration: 300ms;
}
.dark-mode .suggestion-item:hover .suggestion-text {
  color: greenyellow !important;
}

.suggestions-box {
  background-color: white !important;
}
.dark-mode .suggestions-box {
  background-color: #041d3c !important;
}

.active-section {
  background-color: transparent;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 20px;
  padding-bottom: 10px;
}

.active-section .brand-header {
  color: #ffffff;
  font-weight: bold;
  padding: 10px 15px;
  background-color: transparent;
  margin-bottom: 10px;
}

.active-section .brand-header i {
  color: #ffffff;
  opacity: 0.8;
}

.active-brand-group {
  margin-bottom: 15px;
}

.active-brand-name {
  color: #4CAF50;
  font-weight: 600;
  padding: 8px 15px;
  font-size: 0.9rem;
  background-color: transparent;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.active-brand-name:hover {
  background-color: rgba(76, 175, 80, 0.1);
}

.active-brand-name i {
  font-size: 1rem;
  opacity: 0.8;
}

.active-brand-group .olt-item {
  background-color: transparent;
  border-left: 3px solid transparent;
  margin: 0 10px;
}

.active-brand-group .olt-item .olt-name {
  color: inherit;
  font-weight: normal;
}

.active-brand-group .olt-item.selected {
  background-color: rgba(76, 175, 80, 0.1);
  border-left: 3px solid #4CAF50;
}

.active-brand-group .olt-item.selected .olt-name {
  color: #4CAF50;
  font-weight: 500;
}

.text-success {
  color: #4CAF50 !important;
}

.text-warning {
  color: #FFC107 !important;
}

.text-danger {
  color: #F44336 !important;
}
</style>